"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formErrorIcon = exports.formError = void 0;
const tw_1 = require("../utils/tw");
exports.formError = (0, tw_1.tw)(`
  hidden items-start gap-xs pt-xs text-xs font-semibold leading-xs tracking-lg
  text-critical
  group-[[data-has-error]]:flex
  data-[validator="fail"]:data-[dirty]:flex
  peer-[[status=error]]:data-[validator="fail"]:flex
`);
exports.formErrorIcon = (0, tw_1.tw)(`shrink-0`);
